import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { FiArrowLeft, FiRefreshCw } from "react-icons/fi";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import OTPInput from "react-otp-input";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CheckIsNull } from "../../../../utils/CommonHelper";
import {
  ErrorContainer,
  Input,
  PhoneInputField,
} from "../../../common/components/control/InputField";
import {
  fetchVerificationCode,
  register,
  registerStep2,
} from "../../api/loginapi";
import { LoginTab } from "../../enum/LoginTab";
import { RegisterStep3Schema } from "../../yupSchema/registerSchema";
import { useAuth } from "../AuthInit";

export const RegisterTab = ({ setLoginTab, setSwalProps, loginTab }) => {
  const [seconds, setSeconds] = useState(0);
  const [otp, setOTP] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl();
  const [isShowOtpError, setIsShowOTPError] = useState(false);
  const [isShowPhoneNoError, setIsShowPhoneNoError] = useState(false);
  const [verifyImage, setVerifyImageUrl] = useState("");
  const [otpErrorDescription, setOtpErrorDescription] = useState("");
  const [phoneNoErrorDescription, setPhoneNoErrorDescription] = useState("");
  const [registerDetail, setRegisterDetail] = useState();
  const { saveAuth, setCurrentUser } = useAuth();
  const [phoneCode, setPhoneCode] = useState("my");
  const codeNum = useRef("");
  const formikRef = useRef();
  const dateNow = Date.now();
  const { refferalCode } = useParams();
  const currentLocale = localStorage.getItem("locale");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (seconds === 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const getVerificationCode = () => {
    setVerifyImageUrl("");
    codeNum.current = "";
    fetchVerificationCode().then((resp) => {
      setVerifyImageUrl(resp.imageurl);
      codeNum.current = resp.verificationcode;
    });
  };
  const handleLanguageChange = (language) => {
    if (sessionStorage.getItem("platform") === "mobile") {
      console.log("update:language");
      localStorage.setItem("locale", language);
      // window.location.reload();
    } else {
      localStorage.setItem("locale", language);
      window.location.reload();
    }
  };
  useEffect(() => {
    getVerificationCode();
  }, []);

  const handleBack = () => {
    console.log(location.pathname);
    if (loginTab === LoginTab.REGISTER_PART_1) {
      if (location.pathname === "/register") {
        navigate("/");
      } else {
        setLoginTab(LoginTab.LOGIN);
      }
    } else {
      setLoginTab(LoginTab.REGISTER_PART_1);
    }
  };

  const renderRegisterComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        <div style={{ marginLeft: "20px", marginTop: "20px" }}>
          <button
            onClick={handleBack}
            style={{ background: "none", border: "none" }}
          >
            <FiArrowLeft size={25} style={{ color: "white" }} />
          </button>
        </div>
        <div style={{ textAlign: "center" }}>
          <h3 style={{ color: "white" }}>
            {intl.formatMessage({ id: "register" })}
          </h3>
        </div>
        <div style={{ margin: "10px", color: "white", textAlign: "center" }}>
          <span
            style={{
              color:
                loginTab === LoginTab.REGISTER_PART_1
                  ? "rgb(245, 190, 9)"
                  : "white",
            }}
          >
            1
          </span>
          <div
            style={{
              display: "inline-block",
              width: "15%",
              verticalAlign: "middle",
              borderTop: "1px solid white",
              marginLeft: "5px",
              marginRight: "5px",
            }}
          ></div>
          <span
            style={{
              color:
                loginTab === LoginTab.REGISTER_PART_2
                  ? "rgb(245, 190, 9)"
                  : "white",
            }}
          >
            2
          </span>
        </div>
        <div style={{ width: "100%" }}>
          {loginTab === LoginTab.REGISTER_PART_1 ? (
            <Formik
              initialValues={{
                phoneNo: registerDetail ? registerDetail.telno : "",
                referralCode: refferalCode
                  ? refferalCode
                  : registerDetail
                  ? registerDetail.referrerid
                  : "",
                verifyCode: "",
              }}
              innerRef={formikRef}
              //  validationSchema={RegisterStep1Schema(intl)}
              enableReinitialize={true}
              onSubmit={(values, formikHelpers) => {
                if (codeNum.current === values.verifyCode) {
                  setIsLoading(true);
                  const queryParams = {
                    telno: values.phoneNo,
                    inviteid: values.referralCode,
                    uniqueid: dateNow,
                    languagecode: intl.locale,
                  };
                  register(queryParams).then((resp) => {
                    setIsLoading(false);
                    getVerificationCode();
                    formikHelpers.setFieldValue("verifyCode", "");
                    if (parseInt(resp.code) === 0) {
                      setSeconds(60);
                      setRegisterDetail({
                        ...queryParams,
                        effkey: resp.effkey,
                      });
                      setLoginTab(LoginTab.REGISTER_PART_2);
                    } else {
                      setIsShowPhoneNoError(true);
                      setPhoneNoErrorDescription(resp.message);
                    }
                  });
                } else {
                  formikHelpers.setFieldError(
                    "verifyCode",
                    intl.formatMessage({ id: "incorrectVerificationCode" })
                  );
                }
              }}
            >
              {({
                values,
                handleSubmit,
                setFieldValue,
                touched,
                errors,
                setFieldError,
                setFieldTouched,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "2%",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "5%",
                        paddingRight: "5%",
                        width: "90%",
                        boxSizing: "border-box",
                      }}
                    >
                      <label
                        className="mb-2 text-input-label"
                        style={{ color: "white" }}
                      >
                        {intl.formatMessage({ id: "phoneNo" })}
                      </label>
                      <PhoneInputField
                        values={values}
                        setFieldValue={setFieldValue}
                        setIsShowPhoneNoError={setIsShowPhoneNoError}
                        isShowPhoneNoError={isShowPhoneNoError}
                        phoneNoErrorDescription={phoneNoErrorDescription}
                        setPhoneNoErrorDescription={setPhoneNoErrorDescription}
                        name="phoneNo"
                        country={phoneCode}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "2%",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "5%",
                        paddingRight: "5%",
                        width: "90%",
                        boxSizing: "border-box",
                      }}
                    >
                      <label
                        className="mb-2 text-input-label"
                        style={{ color: "white" }}
                      >
                        {intl.formatMessage({ id: "refferalCode" })}
                      </label>
                      <Field
                        name="referralCode"
                        component={Input}
                        placeholder={intl.formatMessage({ id: "refferalCode" })}
                        autoComplete="off"
                        readOnly={refferalCode ? true : false}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "2%",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "5%",
                        paddingRight: "5%",
                        width: "90%",
                        boxSizing: "border-box",
                      }}
                    >
                      <label
                        className="mb-2 text-input-label"
                        style={{ color: "white" }}
                      >
                        {intl.formatMessage({ id: "verificationCode" })}
                      </label>
                      <div className="mb-2">
                        {CheckIsNull(verifyImage) ? (
                          <Skeleton
                            className="col-4"
                            style={{ height: "60px" }}
                          />
                        ) : (
                          <>
                            <img
                              src={verifyImage}
                              alt="verifyImage"
                              className="col-4 me-4"
                              style={{ height: "60px" }}
                            />
                            <FiRefreshCw
                              style={{ color: "white", marginLeft: "5px" }}
                              onClick={() => getVerificationCode()}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mb-2"></div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "2%",
                    }}
                  >
                    <div
                      style={{
                        paddingLeft: "5%",
                        paddingRight: "5%",
                        width: "90%",
                        boxSizing: "border-box",
                      }}
                    >
                      <Field
                        name="verifyCode"
                        component={Input}
                        placeholder={intl.formatMessage({
                          id: "verificationCode",
                        })}
                        autoComplete="off"
                        readOnly={isLoading}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      paddingTop: "2%",
                    }}
                  >
                    <button
                      type="submit"
                      disabled={isLoading}
                      style={{
                        width: "60%",
                        height: 35,
                        borderRadius: 15,
                        backgroundColor: "rgb(245, 190, 9)",
                        fontWeight: "bold",
                        color: "black",
                        fontSize: "12px",
                      }}
                    >
                      {isLoading && (
                        <div
                          className="spinner-border"
                          role="status"
                          style={{ scale: "0.75" }}
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                      {intl.formatMessage({ id: "requestOTP" })}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          ) : (
            <div style={{ width: "100%" }}>
              <Formik
                initialValues={{
                  username: "",
                  userPassword: "",
                }}
                innerRef={formikRef}
                validationSchema={RegisterStep3Schema(intl)}
                enableReinitialize={true}
                onSubmit={(values, formikHelpers) => {
                  if (!CheckIsNull(otp)) {
                    setIsShowOTPError(false);
                    setIsLoading(true);
                    registerStep2({
                      ...registerDetail,
                      otpcode: otp,
                      username: values.username,
                      password: values.userPassword,
                    }).then((resp) => {
                      setIsLoading(false);
                      setOTP("");
                      if (parseInt(resp.code) === 0) {
                        setSwalProps({
                          show: true,
                          icon: "success",
                          title: intl.formatMessage({ id: "success" }),
                          text: intl.formatMessage({
                            id: "registerSuccess",
                          }),
                          onConfirm: () => {
                            saveAuth(resp);
                            setCurrentUser(resp);
                            setLoginTab(LoginTab.LOGIN);
                          },
                        });
                      } else {
                        setSwalProps({
                          show: true,
                          icon: "error",
                          title: intl.formatMessage({ id: "error" }),
                          text: resp.message,
                        });
                      }
                    });
                  }
                }}
              >
                {({
                  values,
                  handleSubmit,
                  setFieldValue,
                  touched,
                  errors,
                  setFieldError,
                }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingTop: "2%",
                      }}
                    >
                      <div
                        style={{
                          paddingLeft: "5%",
                          paddingRight: "5%",
                          width: "90%",
                          boxSizing: "border-box",
                        }}
                      >
                        <label
                          className="mb-2 text-input-label"
                          style={{ color: "white" }}
                        >
                          {intl.formatMessage({ id: "username" })}
                        </label>
                        <div className="mb-2">
                          <Field
                            name="username"
                            component={Input}
                            placeholder={intl.formatMessage({ id: "username" })}
                            autoComplete="off"
                            pattern="[a-zA-Z0-9]*"
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          paddingLeft: "5%",
                          paddingRight: "5%",
                          width: "90%",
                          boxSizing: "border-box",
                        }}
                      >
                        <label
                          className="mb-2 text-input-label"
                          style={{ color: "white" }}
                        >
                          {intl.formatMessage({ id: "password" })}
                        </label>
                        <div className="mb-2">
                          <Field
                            name="userPassword"
                            component={Input}
                            placeholder={intl.formatMessage({ id: "password" })}
                            autoComplete="off"
                            type="password"
                          />
                        </div>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            color: "white",
                            textAlign: "center",
                            width: "70%",
                            margin: "0 auto",
                          }}
                        >
                          {intl.formatMessage({ id: "otpHasSended" })}
                          {"(+"}
                          {registerDetail.telno}
                          {")"}
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                          <OTPInput
                            value={otp}
                            onChange={setOTP}
                            numInputs={4}
                            containerStyle="justify-content-center"
                            shouldAutoFocus={true}
                            renderSeparator={<div className="mx-2 mb-3"></div>}
                            renderInput={(props) => (
                              <input
                                {...props}
                                className="form-control otp-field"
                                inputMode="numeric"
                              />
                            )}
                          />
                          <div
                            className="d-flex justify-content-center mt-2"
                            style={{ fontSize: "12px" }}
                          >
                            <div
                              className={`cursor-pointer ${
                                seconds > 0 ? "text-muted" : "text-warning"
                              }`}
                              onClick={() => {
                                register(registerDetail).then((resp) => {
                                  if (parseInt(resp.code) === 0) {
                                    setSeconds(60);
                                    setRegisterDetail({
                                      ...registerDetail,
                                      effkey: resp.effkey,
                                    });
                                    setSwalProps({
                                      show: true,
                                      position: "bottom",
                                      text: intl.formatMessage({
                                        id: "resendSuccessfully",
                                      }),
                                      timer: 1000,
                                      showConfirmButton: false,
                                      toast: true,
                                      width: "13.2rem",
                                    });
                                  }
                                });
                              }}
                            >
                              {intl.formatMessage(
                                { id: "resendOtp" },
                                { X: seconds }
                              )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-center mt-2">
                            <ErrorContainer
                              isShow={isShowOtpError}
                              errorMsg={otpErrorDescription}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          paddingLeft: "5%",
                          paddingRight: "5%",
                          width: "90%",
                          boxSizing: "border-box",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            paddingTop: "2%",
                          }}
                        >
                          <button
                            type="submit"
                            disabled={isLoading}
                            onClick={() => {
                              if (CheckIsNull(otp)) {
                                setIsShowOTPError(true);
                                setOtpErrorDescription(
                                  intl.formatMessage({ id: "otpRequired" })
                                );
                              }
                            }}
                            style={{
                              width: "60%",
                              height: 35,
                              borderRadius: 15,
                              backgroundColor: "rgb(245, 190, 9)",
                              fontWeight: "bold",
                              color: "black",
                              fontSize: "12px",
                            }}
                          >
                            {isLoading && (
                              <div
                                className="spinner-border"
                                role="status"
                                style={{ scale: "0.75" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            )}
                            {intl.formatMessage({ id: "register" })}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "0 auto",
            width: "90%",
            marginTop: 20,
            marginBottom: 20,
            padding: 5,
          }}
        >
          {currentLocale !== "ms" && (
            <img
              src={`${process.env.PUBLIC_URL}/image/my.png`}
              style={{ height: "30px", width: "30px", marginLeft: "10px" }}
              onClick={() => handleLanguageChange("ms")}
            />
          )}
          {currentLocale !== "en" && (
            <img
              src={`${process.env.PUBLIC_URL}/image/en.png`}
              style={{ height: "30px", width: "30px", marginLeft: "10px" }}
              onClick={() => handleLanguageChange("en")}
            />
          )}
          {currentLocale !== "zh" && (
            <img
              src={`${process.env.PUBLIC_URL}/image/cn.png`}
              style={{ height: "30px", width: "30px", marginLeft: "10px" }}
              onClick={() => handleLanguageChange("zh")}
            />
          )}
          {currentLocale !== "id" && (
            <img
              src={`${process.env.PUBLIC_URL}/image/id.png`}
              style={{ height: "30px", width: "30px", marginLeft: "10px" }}
              onClick={() => handleLanguageChange("id")}
            />
          )}
        </div>
        <p
          style={{
            color: "white",
            textAlign: "center",
            fontSize: 13,
            paddingTop: "2%",
          }}
        >
          {intl.formatMessage({ id: "alreadyHaveAccount" })}{" "}
          <button
            onClick={() => {
              setLoginTab(LoginTab.LOGIN);
            }}
            style={{
              cursor: "pointer",
              border: "none",
              background: "none",
              color: "white",
              textDecoration: "underline",
            }}
          >
            {intl.formatMessage({ id: "login" })}
          </button>
        </p>
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "transparent",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>{renderRegisterComponent()}</div>
    </div>
  );
};
